/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-16 12:52:46
 * @name: 工单管理-安排上门人
 * @Description: 工单管理-安排上门人
 * @FilePath: \project\src\module\issue\validator\homeService.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'user_id',
    description: '指定上门人id',
    required: true,
    required_message: '请指定上门人',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请指定上门人';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'remark',
    description: '上门服务内容',
    required: true,
    required_message: '上门内容不能为空',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '上门内容不能为空';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
]